import { render, staticRenderFns } from "./selectCampus.vue?vue&type=template&id=088ae75d&scoped=true&"
import script from "./selectCampus.vue?vue&type=script&lang=js&"
export * from "./selectCampus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088ae75d",
  null
  
)

export default component.exports